import { useEffect, useState } from "react";
import { gxfileviewApi } from "@/app/apiConfig/services/customerAbstractApiLayer";

export const useCompanyLogo = (vcifId?: string | null) => {
  const [companyLogo, setCompanyLogo] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!vcifId) {
      setCompanyLogo(null);
      return;
    }

    let cancelled = false;

    const fetchLogo = async () => {
      setIsLoading(true);
      try {
        const response = await gxfileviewApi({
          documentType: "LOGO",
          vcifId,
        });
        const doc = Array.isArray(response?.data)
          ? response.data[0]
          : response?.data;

        if (!cancelled && doc?.base64Output) {
          const ext = doc.fileName?.split(".").pop()?.toLowerCase();
          const mime =
            ext === "jpg" || ext === "jpeg"
              ? "image/jpeg"
              : ext === "svg"
                ? "image/svg+xml"
                : ext === "gif"
                  ? "image/gif"
                  : "image/png";
          setCompanyLogo(`data:${mime};base64,${doc.base64Output}`);
        } else if (!cancelled) {
          setCompanyLogo(null);
        }
      } catch (error) {
        console.log(error);
        if (!cancelled) setCompanyLogo(null);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchLogo();
    return () => {
      cancelled = true;
    };
  }, [vcifId]);

  return { companyLogo, isLoading };
};
